import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { collection, onSnapshot, getFirestore } from 'firebase/firestore';
import '../css/Dashboard.css';
import Loading from '../components/Loading'; // Your Loading component
import BackButton from '../components/BackButton';

const Dashboard = () => {
    const [loading, setLoading] = useState(true);
    const [todayOrders, setTodayOrders] = useState(0);
    const [totalSchemes, setTotalSchemes] = useState(0);
    const [onboardingSchemes, setOnboardingSchemes] = useState(0);
    const [activeSchemes, setActiveSchemes] = useState(0);
    const [completedSchemes, setCompletedSchemes] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalCRMUsers, setTotalCRMUsers] = useState(0);
    const [inactiveSchemes, setInactiveSchemes] = useState(0);


    const navigate = useNavigate();
    const db = getFirestore();

    const fetchSchemes = () => {
        const schemesRef = collection(db, 'schemes');
    
        const unsubscribe = onSnapshot(schemesRef, (snapshot) => {
            let total = 0;
            let onboarding = 0;
            let active = 0;
            let completed = 0;
            let inactive = 0;
    
            const currentDate = new Date();
    
            snapshot.forEach((doc) => {
                const scheme = doc.data();
                total++;
    
                // Parse the string dates into Date objects
                const onboardingStart = scheme.onboardingStart ? new Date(scheme.onboardingStart) : null;
                const onboardingEnd = scheme.onboardingEnd ? new Date(scheme.onboardingEnd) : null;
    
                // Active duration calculation (e.g., assume it's 30 days after onboardingEnd)
                const activeEnd = onboardingEnd
                    ? new Date(new Date(onboardingEnd).setDate(new Date(onboardingEnd).getDate() + 30))
                    : null;
    
                // Determine the status based on dates
                if (onboardingStart && onboardingEnd && currentDate >= onboardingStart && currentDate <= onboardingEnd && scheme.status !== "Completed") {
                    onboarding++;
                }
                
                if (scheme.status === true) {
                    active++;
                }
                if (scheme.status === false) {
                    inactive++;
                }
                if (scheme.status === "Completed") {
                    completed++;
                }
            });
    
            setTotalSchemes(total);
            setOnboardingSchemes(onboarding);
            setActiveSchemes(active);
            setCompletedSchemes(completed);
            setInactiveSchemes(inactive); // Add a new state for inactive schemes
        });
    
        return unsubscribe;
    };
    
    
    // Function to fetch real-time scheme counts
    // const fetchSchemeCounts = () => {
    //     const schemesRef = collection(db, 'schemes');

    //     const unsubscribe = onSnapshot(schemesRef, (snapshot) => {
    //         let totalSchemesCount = 0;
    //         let onboardingCount = 0;
    //         let activeCount = 0;
    //         let completedCount = 0;

    //         snapshot.forEach((doc) => {
    //             const scheme = doc.data();
    //             totalSchemesCount++;

    //             if (scheme.status === 'Onboarding') {
    //                 onboardingCount++;
    //             } else if (scheme.status === 'Active') {
    //                 activeCount++;
    //             } else if (scheme.status === 'Completed') {
    //                 completedCount++;
    //             }
    //         });

    //         setTotalSchemes(totalSchemesCount);
    //         setOnboardingSchemes(onboardingCount);
    //         setActiveSchemes(activeCount);
    //         setCompletedSchemes(completedCount);
    //     });

    //     return unsubscribe;
    // };

    // Function to fetch real-time user counts
    const fetchUserCounts = () => {
        const usersRef = collection(db, 'users');

        const unsubscribe = onSnapshot(usersRef, (snapshot) => {
            let totalUsersCount = 0;

            snapshot.forEach(() => {
                totalUsersCount++;
            });

            setTotalUsers(totalUsersCount);
        });

        return unsubscribe;
    };

    // Function to fetch real-time CRM user counts
    const fetchCRMUserCounts = () => {
        const crmUsersRef = collection(db, 'crm_users');

        const unsubscribe = onSnapshot(crmUsersRef, (snapshot) => {
            let totalCRMUsersCount = 0;

            snapshot.forEach(() => {
                totalCRMUsersCount++;
            });

            setTotalCRMUsers(totalCRMUsersCount);
        });

        return unsubscribe;
    };

    useEffect(() => {
        const unsubscribeSchemes = fetchSchemes();
        const unsubscribeUsers = fetchUserCounts();
        const unsubscribeCRMUsers = fetchCRMUserCounts();

        setLoading(false);

        return () => {
            unsubscribeSchemes();
            unsubscribeUsers();
            unsubscribeCRMUsers();
        };
    }, []);

    const handleViewMore = () => navigate('/orders');
    const handleViewMore2 = () => navigate('/customers');

    if (loading) {
        return (
            <div>
                <Loading />
            </div>
        );
    }

    return (
        <Container fluid className="p-4">
          
                <Row>
                    <Col md={10}>
                        <h3>Scheme Overview</h3>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{totalSchemes}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h5 className="cus-head">Total Schemes</h5>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{onboardingSchemes}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h5 className="cus-head">Onboarding Schemes</h5>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{activeSchemes}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h5 className="cus-head">Active Schemes</h5>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{inactiveSchemes}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h5 className="cus-head">Inactive Schemes</h5>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{completedSchemes}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h5 className="cus-head">Completed Schemes</h5>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={10}>
                        <h3>Users Overview</h3>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{totalCRMUsers}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h4 className="cus-head">Total CRM Users</h4>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="mb-4">
                            <Card.Body>
                                <center>
                                    <Card.Text>
                                        <h1 className="cus-count">{totalUsers}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <h4 className="cus-head">Total Users</h4>
                                    </Card.Title>
                                </center>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            

    );
};

export default Dashboard;
